export enum PixTypeEnum {
  EMAIL = "EMAIL",
  DOCUMENT = "DOCUMENT",
  PHONE = "PHONE",
  BANK_ACCOUNT = "BANK_ACCOUNT",
}
